var render = function render(){var _vm=this,_c=_vm._self._c;return _c('regra-form',{attrs:{"form":_vm.form},scopedSlots:_vm._u([{key:"button",fn:function({ invalid }){return [_c('v-btn',{attrs:{"color":"primary","disabled":invalid},on:{"click":_vm.save}},[_vm._v("Salvar")])]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }